import { catchError, map, Observable, of, tap } from 'rxjs';
import { FarmApi } from '@features/farm/data-access/farm-api';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class facade {
	constructor(private farmService: FarmApi) {}

	getFarmByIdFacade(id: string): Observable<string> {
		return this.farmService.getFarmById({ id }).pipe(
			map((response) => response?.farm?.name ?? ''),
			catchError(() => of('')),
		);
	}
}
